const locale = {
	HEADERMESSAGE: 'Welcome,',
	HEADERSUBMESSAGEUSER: 'please sign in to your account.',
	HEADERSUBMESSAGECOMPANY: "please enter your company shortcode.",
	HEADERSUBMESSAGENFC: "please sign in to your NFC tag.",
	COMPANY: 'Company',
	COMPANYCODE: 'Companycode',
	USERNAME: 'Username',
	PASSWORD: 'Password',
	KEEPLOGIN: "Keep me logged in",
	FORGOTPW: "Forgot your password?",
	SUBMITCOMPANY: "Continue",
	SUBMITLOGIN: "Login",
	COMPANYREQUIRED: "Please enter your companyshortname",
	USERNAMEREQUIRED: "Please enter your username",
	PASSWORDREQUIRED: "Please enter your password",
	INVALIDINPUT: "Your input contains invalid characters",
	SHORTINPUT: "Your input is too short",
	NOCUSTOMERYET: "No ABS customer?",
	BECOMENEWCUSTOMER: "Request now",
	NOCOMPANYFOUND: "No company with this code could be found",
	YOUHAVELOGGEDOUT: "You have signed out!",
	ALTERNATIVELOGIN: "Alternatively login via",
	NFCLOGIN: "NFC Login",
	PASSWORDLOGIN: "Login with password",
	WAITINGFORTAG: "Waiting for a chip to scan...",
	STARTNEWSCAN: "Start new scan",
	NFCNOTAVAILABLE: "NFC is not available",
	NFCNOTACTIVATED: "NFC is not activated",
	NFCNOTSUPPORTED: "NFC is not supported on this device",
	NONFCCHIPFOUND: "No NFC chip found",
	NFCCHIPNOTFORMATTED: "NFC chip not formatted",
	NFCCHIPNOTSUPPORTED: "NFC chip not supproted",
	NFCHIPDETECTED: "NFC chip detected, please wait",
	NFCCHIPUPDATENOTSUPPORTED: "NFC chip udpate not supported on this device",
	NFCHIPRESETSUCCESSFULL: "NFC chip reset successfull",
	NFCHIPUPDATESUCCESSFULL: "NFC chip update successfull",
	NFCDIFFERENTCHIPDETECTED: "Different NFC chip deteceted, operation canceled",
	NFCERROR: "NFC error, operation canceled",
	WAITINGONCHIPFORFORMAT: "Waiting for NFC chip {{chipid}} to format",
	WAITINGONCHIPFORUPDATE: "Waiting for NFC chip {{chipid}} to update",
	OR: "Or",
	NFCHIPINFO: "NFC Chip Info",
	DSGVO: "Privacy Policy",
	AGB: "Terms & Conditions",
	COPYRIGHT: "Copyright © Alpsware GmbH",
};

export default locale;
